"use client";

import { Toaster } from "sonner";

const ToasterProvider = () => {
	return <Toaster richColors position='top-center' />;
};

export default ToasterProvider;
